import React from 'react';
import dayjs from 'dayjs';
import { CellRenderer, CellRendererProps } from '../_custom/DataTable/DataTable.types';

import styles from './ReadOnlyField.module.scss';

export const ReadOnlyLastStatusUpdateRenderer: React.FC<CellRendererProps> = ({ value }) => {
    if (!value) return <span>-</span>;
    return <span>{dayjs(value).format('h:mm A, DD MMM YYYY')}</span>;
};

export type ModalActionConfigMap = Record<string, { computeData?: (row: any) => { statusLabel?: string } | undefined; [key: string]: any }>;

// Label-only; reuses the host's `computeData` so the text matches the table.
export function makeReadOnlyModalActionRenderer(modalActionConfig: ModalActionConfigMap | undefined): CellRenderer {
    const Renderer: React.FC<CellRendererProps> = ({ row, column }) => {
        const statusLabel = modalActionConfig?.[column.field]?.computeData?.(row)?.statusLabel;
        return <span>{statusLabel ?? '-'}</span>;
    };
    return Renderer;
}

export const ReadOnlyCompanyNameRenderer: React.FC<CellRendererProps> = ({ value }) => {
    if (value === null || value === undefined || value === '') return <span>-</span>;
    return <span>{value}</span>;
};

// Grey-filled, borderless box for values the drawer never edits.
export function withReadOnlyFieldBox(Inner: CellRenderer): CellRenderer {
    const ReadOnlyFieldBox: React.FC<CellRendererProps> = (props) => (
        <div className={styles.FieldBoxReadOnly}>
            <Inner {...props} />
        </div>
    );
    return ReadOnlyFieldBox;
}
